import React, { useEffect, useState } from "react";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import { Calendar } from "lucide-react";
import { formatDate } from "../../functions/dateTime/formatDate";
import useClickOutside from "../../CustomHooks/useClickOutside";
import { formatDateString } from "../../functions/dateTime/formatDateString";

const DateInput = ({ label, name, value = "", error, onChange }) => {
  const [date, setDate] = useState(value);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const { dropdownRef } = useClickOutside(() => setShowDatePicker(false));

  useEffect(() => {
    setDate(value);
  }, [value]);

  const today = new Date();
  const currentYear = today.getFullYear();
  const disabledDays = (() => {
    const today = new Date();
    return {
      after: new Date(today.getFullYear(), today.getMonth(), today.getDate()), // Disable future days but not today
    };
  })();

  const handleDateChange = (selectedDate) => {
    if (!selectedDate) return;

    onChange?.({
      target: {
        name,
        value: formatDateString(selectedDate),
      },
    });

    setShowDatePicker(false);
  };

  return (
    <div className="relative top-1" ref={dropdownRef}>
      <div
        onClick={() => setShowDatePicker((prev) => !prev)}
        className="cursor-pointer"
      >
        <label
          htmlFor="custom-calendar"
          className="text-[10px] lg:text-xs font-poppins absolute left-2 pr-2 py-1 top-[3px] lg:top-2 bg-white"
        >
          {value ? formatDate(value) : `Select ${label}`}
        </label>
        <Calendar
          color="gray"
          className="absolute right-1 top-[4px] w-3 lg:top-1 lg:w-4"
        />
        <input
          name={name}
          type="text"
          readOnly="readonly"
          value={value ? formatDate(value) : ""}
          className={`w-full border-bw text-[10px] lg:text-xs rounded-md cursor-pointer py-1 lg:py-[9px] px-2 lg:px-3 focus-input ${
            error ? "border-red-500" : "border-lg4"
          }`}
        />
      </div>
      {showDatePicker && (
        <div className="shadow-sh-1 max-w-xs absolute left-0 top-12 bg-white z-9999">
          <DayPicker
            mode="single"
            captionLayout="dropdown"
            fromYear={2020}
            toYear={currentYear}
            selected={date}
            disabled={disabledDays}
            onSelect={handleDateChange}
            classNames={{
              caption_label:
                "font-bold font-poppins flex items-center mr-3 mb-2",
              head_row: "flex font-medium text-gray-900",
              head_cell: "w-7 font-normal text-sm",
              row: "flex w-full",
              cell: "text-gray-600 rounded-md h-7 w-7 text-center text-sm p-0",
              day: "h-7 w-7 p-0 font-normal",
              day_range_end: "day-range-end",
              day_selected:
                "rounded-md text-white hover:bg-gray-900 hover:text-white focus:bg-gray-900 focus:text-white",
            }}
          />
        </div>
      )}
      <p
        className={`text-red-500 font-figtree text-[10px] lg:text-xs h-3 lg:h-4 ${
          error ? "visible" : "invisible"
        }`}
      >
        {error?.message}
      </p>
    </div>
  );
};

export default DateInput;
